import { getStorageItem, removeStorageItem, setStorageItem } from "@testavivadk/utilities";
import { shopifyCartIdStorageKey } from "@constants";
import type { IUserDetails } from "@types";

// Per-user so several users sharing a machine keep separate carts.
const getUserCartIdStorageKey = (userId: IUserDetails["id"]) => `${shopifyCartIdStorageKey}_${userId}`;

export const getShopifyCartId = (userId: IUserDetails["id"]): string | null =>
  (getStorageItem(getUserCartIdStorageKey(userId)) as string | null) ?? null;

export const persistShopifyCartId = (userId: IUserDetails["id"], cartId: string) => {
  setStorageItem(getUserCartIdStorageKey(userId), cartId);
};

export const clearShopifyCartId = (userId: IUserDetails["id"]) => {
  removeStorageItem(getUserCartIdStorageKey(userId));
};
